import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedCustomerDocumentImagesQueryParamsType,
  GetDamagedCustomerDocumentImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerDocumentImages/getDamagedCustomerDocumentImagesQuery.type';

export const getDamagedCustomerDocumentImagesFunction = (
  params: GetDamagedCustomerDocumentImagesQueryParamsType,
): Promise<GetDamagedCustomerDocumentImagesQueryResponseType[]> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/images/customer/document/`,
    { params: { damaged_id: params.damaged_id } },
  );
};
